import { useState } from 'react';

import { IconButton } from '@mui/material';

import { DeleteOutlined } from '@mui/icons-material';

import { graphql, type DocumentType } from '@/gql';

import { PostCommentDeleteDialog } from './PostCommentDeleteDialog';

const POST_COMMENT_DELETE_BUTTON_COMMENT_FRAGMENT = graphql(`
  fragment postCommentDeleteButtonCommentFragment on PostComment {
    ...postCommentDeleteDialogCommentFragment
  }
`);

const POST_COMMENT_DELETE_BUTTON_POST_FRAGMENT = graphql(`
  fragment postCommentDeleteButtonPostFragment on Post {
    ...postCommentDeleteDialogPostFragment
  }
`);

interface Props {
  post: DocumentType<typeof POST_COMMENT_DELETE_BUTTON_POST_FRAGMENT>;
  comment: DocumentType<typeof POST_COMMENT_DELETE_BUTTON_COMMENT_FRAGMENT>;
}

export const PostCommentDeleteButton = ({ post, comment }: Props) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <IconButton onClick={() => setDialogOpen(true)}>
        <DeleteOutlined />
      </IconButton>
      <PostCommentDeleteDialog
        post={post}
        comment={comment}
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </>
  );
};
